import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProductUid } from '@constants';
import { ChildPageRoute, GC_EXCLUSIVE_PATHS, GknRoutePath } from 'src/app/app-routing.enum';

@Injectable()
export class AppHeaderProductSelectService {
    private router = inject(Router);

    /**
     * Checks if the current route is a Genesys Cloud exclusive path.
     * @returns {boolean} Returns true if the current URL path starts with any of the GC exclusive paths, false otherwise.
     */
    private isGCExclusiveRoute(): boolean {
        const currentPath = this.router.url.split('?')[0]; // Remove query parameters
        const gcExclusivePaths = Object.values(GC_EXCLUSIVE_PATHS);
        return gcExclusivePaths.some((path) => currentPath.startsWith(path));
    }

    /**
     * Handle Product Navigation.
     * NOTE: Guards do not handle product selection changes. Do not delete this.
     * @param selectedUid - Selected Product UID
     * @returns void
     */
    handleProductNavigation(selectedUid: ProductUid): void {
        if (!selectedUid) {
            return;
        }

        // If switching away from Genesys Cloud and currently on a GC-exclusive page,
        // navigate appropriately based on the current route
        if (selectedUid !== ProductUid.GENESYS_CLOUD_CX && this.isGCExclusiveRoute()) {
            // Check if currently on roadmap archives page
            if (this.router.url.includes(`/${GknRoutePath.HOME}/${ChildPageRoute.ROADMAP_ARCHIVES}`)) {
                // Redirect to home page for roadmap archives
                this.router.navigate([`/${GknRoutePath.HOME}`], {
                    queryParams: { product: selectedUid },
                    queryParamsHandling: 'merge',
                    preserveFragment: true,
                });
            } else {
                // Redirect to Product Knowledge page for other GC-exclusive pages
                this.router.navigate([`/${GknRoutePath.RESOURCES}/${ChildPageRoute.PRODUCT_KNOWLEDGE}`], {
                    queryParams: { product: selectedUid },
                    queryParamsHandling: 'merge',
                    preserveFragment: true,
                });
            }
        }
    }
}
